import MarketStats from 'app/shared/models/MarketStats';
import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => new MarketStats();

export const marketStats = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === constants.SET_MARKET_STATS) {
        return assign({}, state, payload);
    }
    return state;
};

// used for FAQ params
export const unfilteredMarketStats = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === constants.SET_UNFILTERED_MARKET_STATS) {
        return assign({}, state, payload);
    }
    return state;
};
